// extracted by mini-css-extract-plugin
export default {"button":"Buttons_button__siqpX","button--main":"Buttons_button--main__0Sg-o","button--white":"Buttons_button--white__hG+Uz"};